module.exports = __webpack_public_path__ + "img/Background7.1f32177d.png";